/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Open_PlanInputs */

const en_us2_search_open_plan = /** @type {(inputs: Search_Open_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open in the plan`)
};

const pt_br2_search_open_plan = /** @type {(inputs: Search_Open_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir no plano`)
};

const es_419_search_open_plan = /** @type {(inputs: Search_Open_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir en el plan`)
};

const pt_pt2_search_open_plan = /** @type {(inputs: Search_Open_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir no plano`)
};

const fr_fr2_search_open_plan = /** @type {(inputs: Search_Open_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir dans le programme`)
};

const de_de2_search_open_plan = /** @type {(inputs: Search_Open_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Plan öffnen`)
};

const it_it2_search_open_plan = /** @type {(inputs: Search_Open_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri nella scheda`)
};

/**
* | output |
* | --- |
* | "Open in the plan" |
*
* @param {Search_Open_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_open_plan = /** @type {((inputs?: Search_Open_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Open_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_open_plan(inputs)
	if (locale === "es-419") return es_419_search_open_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_search_open_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_search_open_plan(inputs)
	if (locale === "de-DE") return de_de2_search_open_plan(inputs)
	if (locale === "it-IT") return it_it2_search_open_plan(inputs)
	return en_us2_search_open_plan(inputs)
});
export { search_open_plan as "search.open_plan" }